module.exports = __webpack_public_path__ + "img/arrow-white.22639d20.svg";